import { AxiosInstance } from 'axios';
import { TWebConfig } from '@com/core/common/types/webconfig';
import { TLocaleAPI } from '../types/locale';
import { reportEvent } from '../utils/sentry';

export type TWebconfigEndpoints = {
    getWebConfig: (locale: TLocaleAPI) => Promise<TWebConfig | null>;
};

export default (api: AxiosInstance, apiLocale: TLocaleAPI): TWebconfigEndpoints => {
    const getWebConfig = async (locale: TLocaleAPI): Promise<TWebConfig | null> => {
        try {
            const response = await api.get<TWebConfig>(`/v1/webconfig?x-locale=${locale}`, {
                headers: { 'X-Locale': apiLocale },
            });
            return response.data;
        } catch (err) {
            reportEvent('Failed to fetch webconfig', 'getWebConfig()', 'critical', err.config);
            return null;
        }
    };

    return { getWebConfig };
};
